import { FormGroup, FormGroupFeedback, Intent } from '@pinpointhq/thumbtack';
import * as React from 'react';
import Select from 'react-select';
import { useCustomEventEffect } from '../hooks';
import toSentence from '../utilities/toSentence';

interface IMultipleChoiceSelectFieldProps {
  attributeName?: string;
  inputId?: string;
  initialErrors?: string[];
  name: string;
  placeholder?: string;
  options: { value: number | string; label: string }[];
  storedOptions?: (number | string)[];
  handleSelect?(option): void;
}

export default function MultipleChoiceSelectField(props: IMultipleChoiceSelectFieldProps) {
  const { attributeName, handleSelect, inputId, initialErrors = [], name, options, storedOptions, placeholder } = props;
  const [errors, setErrors] = React.useState<string[]>(initialErrors);

  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const { dispatch } = useCustomEventEffect(`multipleChoiceOptionChange:${name}`);

  React.useEffect(() => {
    if (storedOptions) {
      setSelectedOptions(options.filter((option) => storedOptions.includes(option.value)));
    }
  }, [options, storedOptions]);

  function handleChange(selectedItems) {
    setErrors([]);
    setSelectedOptions(selectedItems);
    dispatch(selectedItems);
    if (handleSelect) handleSelect(selectedItems);
  }

  function selectName(index) {
    if (!attributeName) return name;

    return `${name}[${index}][${attributeName}]`;
  }
  return (
    <>
      <Select
        value={selectedOptions}
        options={options}
        name={attributeName ? 'selectBox' : name}
        isMulti={true}
        inputId={inputId || name}
        className={`react-select ${errors.length > 0 ? 'react-select--error' : ''}`}
        classNamePrefix="react-select"
        isSearchable={true}
        closeMenuOnSelect={false}
        onChange={handleChange}
        placeholder={placeholder}
        tabSelectsValue={false}
      />
      {errors.length > 0 && (
        <FormGroup>
          <FormGroupFeedback intent={Intent.DANGER}>{toSentence(initialErrors)}</FormGroupFeedback>
        </FormGroup>
      )}
      {attributeName &&
        selectedOptions.map((option, index) => {
          return <input key={index} type="hidden" name={selectName(index)} value={option.value} />;
        })}
    </>
  );
}
